import React from "react"

import { buildQuery, useQuery } from "micro-graphql-react"

import { studentClient } from "src/graphql-config"

import PieChart from "components/TailoredSectionResultChart"
import WithLoadingIndicator from "components/WithLoadingIndicator"

import loadResultsQuery from "./loadResultsQuery"

const TailoredAssignmentResults = ({ tailoredAssignmentId }) => {
  const loadingState = useQuery(
    buildQuery(
      loadResultsQuery,
      { tailoredAssignmentId },
      { client: studentClient }
    )
  )

  return (
    <WithLoadingIndicator
      loadingState={loadingState}
      error="An error occurred while loading assignment data"
    >
      {({ data }) => {
        const chartData = data.tailoredSectionSummaries
          .map(tailoredSectionSummary => {
            const score = `${(
              tailoredSectionSummary.studentScore * 100
            ).toFixed(2)}%`
            return {
              sectionId: tailoredSectionSummary.tailoredSection.id,
              sectionReviewPath: tailoredSectionSummary.reviewPath,
              label: `${tailoredSectionSummary.tailoredSection.name}\n${score}`,
              data: [
                { x: "Correct", y: tailoredSectionSummary.correctCount },
                {
                  x: "Incorrect",
                  y: tailoredSectionSummary.incorrectCount,
                },
                {
                  x: "Skipped",
                  y: tailoredSectionSummary.skippedCount,
                },
              ].filter(d => d.y > 0),
            }
          })
          .filter(d => d.data.length > 0)

        return (
          <React.Fragment>
            <h1 className="center">
              Results for {data.tailoredAssignment.name}
            </h1>
            <div className="row">
              {chartData.map(chartData => (
                <div className="col-1-2 center" key={chartData.sectionId}>
                  <PieChart chartData={chartData} />
                  <div>
                    <a
                      className="btn solid orange"
                      href={chartData.sectionReviewPath}
                    >
                      Review Answers
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </React.Fragment>
        )
      }}
    </WithLoadingIndicator>
  )
}

export default TailoredAssignmentResults
